module.exports = __webpack_public_path__ + "img/ic_store_trait_top_img3.c7c0d421.png";